import { render, staticRenderFns } from "./xPaymentCard.vue?vue&type=template&id=8ea4e8de"
import script from "./xPaymentCard.vue?vue&type=script&lang=js"
export * from "./xPaymentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports